<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-4">
          <v-card-title class="bg-primary d-flex justify-space-between align-center">
            <div>
              <v-icon class="mr-2">mdi-cog</v-icon>
              Жүйе баптаулары
            </div>
            <v-btn
              color="success"
              :loading="loading"
              @click="saveAllSettings"
            >
              <v-icon start>mdi-content-save</v-icon>
              Барлығын сақтау
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-6">
            <!-- Loading State -->
            <v-progress-linear
              v-if="loading"
              indeterminate
              color="primary"
              class="mb-4"
            ></v-progress-linear>

            <!-- Settings Tabs -->
            <v-tabs v-model="activeTab" bg-color="transparent" color="primary">
              <v-tab value="courses">
                <v-icon class="mr-2">mdi-school</v-icon>
                Курстар
              </v-tab>
              <v-tab value="contact">
                <v-icon class="mr-2">mdi-phone</v-icon>
                Байланыс ақпараты
              </v-tab>
              <v-tab value="about">
                <v-icon class="mr-2">mdi-information</v-icon>
                Біз туралы
              </v-tab>
            </v-tabs>

            <v-window v-model="activeTab" class="mt-6">
              <!-- Courses Tab -->
              <v-window-item value="courses">
                <v-row>
                  <!-- Online Course -->
                  <v-col cols="12" md="4">
                    <v-card class="h-100" outlined>
                      <v-card-title class="bg-primary">
                        <v-icon class="mr-2">mdi-laptop</v-icon>
                        Онлайн курс
                      </v-card-title>
                      <v-card-text>
                        <!-- Title - Multilingual -->
                        <div class="mb-3">
                          <div class="text-caption mb-1">Атауы (Title):</div>
                          <v-text-field
                            v-model="settings['courses.online.title'].kz"
                            label="Қазақша"
                            variant="outlined"
                            density="compact"
                            class="mb-2"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings['courses.online.title'].ru"
                            label="Русский"
                            variant="outlined"
                            density="compact"
                            class="mb-2"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings['courses.online.title'].en"
                            label="English"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                        </div>

                        <!-- Price - Same for all languages -->
                        <v-text-field
                          v-model="settings['courses.online.price'].kz"
                          label="Бағасы (Current Price)"
                          variant="outlined"
                          density="compact"
                          suffix="₸"
                          class="mb-3"
                        ></v-text-field>

                        <!-- Old Price -->
                        <v-text-field
                          v-model="settings['courses.online.oldPrice'].kz"
                          label="Алдынғы бағасы (Old Price)"
                          variant="outlined"
                          density="compact"
                          suffix="₸"
                          class="mb-3"
                          hint="Сызылып көрсетіледі"
                        ></v-text-field>

                        <v-divider class="my-3"></v-divider>
                        <div class="text-caption mb-2">Мүмкіндіктер (Features):</div>

                        <!-- Features - Multilingual -->
                        <div v-for="i in 4" :key="`online-${i}`" class="mb-3">
                          <div class="text-caption mb-1">Мүмкіндік {{ i }}:</div>
                          <v-text-field
                            v-model="settings[`courses.online.feature${i}`].kz"
                            label="Қазақша"
                            variant="outlined"
                            density="compact"
                            class="mb-1"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings[`courses.online.feature${i}`].ru"
                            label="Русский"
                            variant="outlined"
                            density="compact"
                            class="mb-1"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings[`courses.online.feature${i}`].en"
                            label="English"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Offline Course -->
                  <v-col cols="12" md="4">
                    <v-card class="h-100" outlined>
                      <v-card-title class="bg-success">
                        <v-icon class="mr-2">mdi-school</v-icon>
                        Офлайн курс
                      </v-card-title>
                      <v-card-text>
                        <!-- Title - Multilingual -->
                        <div class="mb-3">
                          <div class="text-caption mb-1">Атауы (Title):</div>
                          <v-text-field
                            v-model="settings['courses.offline.title'].kz"
                            label="Қазақша"
                            variant="outlined"
                            density="compact"
                            class="mb-2"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings['courses.offline.title'].ru"
                            label="Русский"
                            variant="outlined"
                            density="compact"
                            class="mb-2"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings['courses.offline.title'].en"
                            label="English"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                        </div>

                        <!-- Price -->
                        <v-text-field
                          v-model="settings['courses.offline.price'].kz"
                          label="Бағасы (Current Price)"
                          variant="outlined"
                          density="compact"
                          suffix="₸"
                          class="mb-3"
                        ></v-text-field>

                        <!-- Old Price -->
                        <v-text-field
                          v-model="settings['courses.offline.oldPrice'].kz"
                          label="Алдынғы бағасы (Old Price)"
                          variant="outlined"
                          density="compact"
                          suffix="₸"
                          class="mb-3"
                          hint="Сызылып көрсетіледі"
                        ></v-text-field>

                        <v-divider class="my-3"></v-divider>
                        <div class="text-caption mb-2">Мүмкіндіктер (Features):</div>

                        <!-- Features - Multilingual -->
                        <div v-for="i in 4" :key="`offline-${i}`" class="mb-3">
                          <div class="text-caption mb-1">Мүмкіндік {{ i }}:</div>
                          <v-text-field
                            v-model="settings[`courses.offline.feature${i}`].kz"
                            label="Қазақша"
                            variant="outlined"
                            density="compact"
                            class="mb-1"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings[`courses.offline.feature${i}`].ru"
                            label="Русский"
                            variant="outlined"
                            density="compact"
                            class="mb-1"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings[`courses.offline.feature${i}`].en"
                            label="English"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Combo Course -->
                  <v-col cols="12" md="4">
                    <v-card class="h-100" outlined>
                      <v-card-title class="bg-warning">
                        <v-icon class="mr-2">mdi-star</v-icon>
                        Комбо курс
                      </v-card-title>
                      <v-card-text>
                        <!-- Title - Multilingual -->
                        <div class="mb-3">
                          <div class="text-caption mb-1">Атауы (Title):</div>
                          <v-text-field
                            v-model="settings['courses.combo.title'].kz"
                            label="Қазақша"
                            variant="outlined"
                            density="compact"
                            class="mb-2"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings['courses.combo.title'].ru"
                            label="Русский"
                            variant="outlined"
                            density="compact"
                            class="mb-2"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings['courses.combo.title'].en"
                            label="English"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                        </div>

                        <!-- Price -->
                        <v-text-field
                          v-model="settings['courses.combo.price'].kz"
                          label="Бағасы (Current Price)"
                          variant="outlined"
                          density="compact"
                          suffix="₸"
                          class="mb-3"
                        ></v-text-field>

                        <!-- Old Price -->
                        <v-text-field
                          v-model="settings['courses.combo.oldPrice'].kz"
                          label="Алдынғы бағасы (Old Price)"
                          variant="outlined"
                          density="compact"
                          suffix="₸"
                          class="mb-3"
                          hint="Сызылып көрсетіледі"
                        ></v-text-field>

                        <!-- Bonus - Multilingual -->
                        <div class="mb-3">
                          <div class="text-caption mb-1">Бонус (Bonus):</div>
                          <v-text-field
                            v-model="settings['courses.combo.bonus'].kz"
                            label="Қазақша"
                            variant="outlined"
                            density="compact"
                            class="mb-2"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings['courses.combo.bonus'].ru"
                            label="Русский"
                            variant="outlined"
                            density="compact"
                            class="mb-2"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings['courses.combo.bonus'].en"
                            label="English"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                        </div>

                        <v-divider class="my-3"></v-divider>
                        <div class="text-caption mb-2">Мүмкіндіктер (Features):</div>

                        <!-- Features - Multilingual -->
                        <div v-for="i in 4" :key="`combo-${i}`" class="mb-3">
                          <div class="text-caption mb-1">Мүмкіндік {{ i }}:</div>
                          <v-text-field
                            v-model="settings[`courses.combo.feature${i}`].kz"
                            label="Қазақша"
                            variant="outlined"
                            density="compact"
                            class="mb-1"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings[`courses.combo.feature${i}`].ru"
                            label="Русский"
                            variant="outlined"
                            density="compact"
                            class="mb-1"
                          ></v-text-field>
                          <v-text-field
                            v-model="settings[`courses.combo.feature${i}`].en"
                            label="English"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-window-item>

              <!-- Contact Tab -->
              <v-window-item value="contact">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-card outlined>
                      <v-card-title>
                        <v-icon class="mr-2">mdi-phone</v-icon>
                        Байланыс деректері
                      </v-card-title>
                      <v-card-text>
                        <v-text-field
                          v-model="settings['contact.phone']"
                          label="Телефон"
                          variant="outlined"
                          density="comfortable"
                          prepend-inner-icon="mdi-phone"
                          class="mb-4"
                          @blur="updateSetting('contact.phone')"
                        ></v-text-field>

                        <v-text-field
                          v-model="settings['contact.address']"
                          label="Мекенжай (RU/KZ/EN)"
                          variant="outlined"
                          density="comfortable"
                          prepend-inner-icon="mdi-map-marker"
                          class="mb-4"
                          @blur="updateSetting('contact.address')"
                        ></v-text-field>

                        <v-text-field
                          v-model="settings['contact.worktime']"
                          label="Жұмыс уақыты (RU/KZ/EN)"
                          variant="outlined"
                          density="comfortable"
                          prepend-inner-icon="mdi-clock"
                          @blur="updateSetting('contact.worktime')"
                        ></v-text-field>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-card outlined>
                      <v-card-title>
                        <v-icon class="mr-2">mdi-information</v-icon>
                        Алдын ала қарау
                      </v-card-title>
                      <v-card-text>
                        <v-list>
                          <v-list-item>
                            <template v-slot:prepend>
                              <v-icon color="primary">mdi-phone</v-icon>
                            </template>
                            <v-list-item-title>{{ getSettingValue('contact.phone') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <template v-slot:prepend>
                              <v-icon color="primary">mdi-map-marker</v-icon>
                            </template>
                            <v-list-item-title>{{ getSettingValue('contact.address') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <template v-slot:prepend>
                              <v-icon color="primary">mdi-clock</v-icon>
                            </template>
                            <v-list-item-title>{{ getSettingValue('contact.worktime') }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-window-item>

              <!-- About Tab -->
              <v-window-item value="about">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-card outlined>
                      <v-card-title>
                        <v-icon class="mr-2">mdi-text</v-icon>
                        Біз туралы мәтін
                      </v-card-title>
                      <v-card-text>
                        <v-textarea
                          v-model="settings['about.description']"
                          label="Сипаттама (RU/KZ/EN)"
                          variant="outlined"
                          rows="4"
                          @blur="updateSetting('about.description')"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>

                    <v-card outlined class="mt-4">
                      <v-card-title>
                        <v-icon class="mr-2">mdi-star</v-icon>
                        Артықшылықтар
                      </v-card-title>
                      <v-card-text>
                        <v-text-field
                          v-for="i in 4"
                          :key="`about-${i}`"
                          v-model="settings[`about.feature${i}`]"
                          :label="`Артықшылық ${i} (RU/KZ/EN)`"
                          variant="outlined"
                          density="comfortable"
                          class="mb-3"
                          @blur="updateSetting(`about.feature${i}`)"
                        ></v-text-field>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-card outlined>
                      <v-card-title>
                        <v-icon class="mr-2">mdi-eye</v-icon>
                        Алдын ала қарау
                      </v-card-title>
                      <v-card-text>
                        <p class="mb-4">{{ getSettingValue('about.description') }}</p>
                        <v-list>
                          <v-list-item v-for="i in 4" :key="`preview-${i}`">
                            <template v-slot:prepend>
                              <v-icon color="primary">
                                {{ ['mdi-school', 'mdi-certificate', 'mdi-clock-fast', 'mdi-phone-in-talk'][i-1] }}
                              </v-icon>
                            </template>
                            <v-list-item-title>{{ getSettingValue(`about.feature${i}`) }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-window-item>
            </v-window>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/utils/api';
import { useSnackbarStore } from '@/stores/snackbar';

const { t, locale } = useI18n();
const snackbar = useSnackbarStore();

const activeTab = ref('courses');
const loading = ref(false);
const settings = ref({});
const originalSettings = ref({});

// Initialize empty multilingual settings structure
const initializeSettings = () => {
  const keys = [
    'courses.online.title',
    'courses.online.price',
    'courses.online.oldPrice',
    'courses.online.feature1',
    'courses.online.feature2',
    'courses.online.feature3',
    'courses.online.feature4',
    'courses.offline.title',
    'courses.offline.price',
    'courses.offline.oldPrice',
    'courses.offline.feature1',
    'courses.offline.feature2',
    'courses.offline.feature3',
    'courses.offline.feature4',
    'courses.combo.title',
    'courses.combo.price',
    'courses.combo.oldPrice',
    'courses.combo.bonus',
    'courses.combo.feature1',
    'courses.combo.feature2',
    'courses.combo.feature3',
    'courses.combo.feature4',
    'contact_phone',
    'contact_email',
    'contact_address',
    'about.description',
    'about.feature1',
    'about.feature2',
    'about.feature3',
    'about.feature4'
  ];
  
  keys.forEach(key => {
    settings.value[key] = { kz: '', ru: '', en: '' };
  });
};

// Load settings from API
const loadSettings = async () => {
  loading.value = true;
  try {
    initializeSettings();
    
    const response = await api.get('/admin/settings');
    
    if (response.data) {
      // API returns object with key-value pairs
      Object.keys(response.data).forEach(key => {
        const settingData = response.data[key];
        // Store all language versions
        settings.value[key] = {
          kz: settingData.kz || settingData.valueKz || '',
          ru: settingData.ru || settingData.valueRu || '',
          en: settingData.en || settingData.valueEn || ''
        };
        originalSettings.value[key] = { ...settingData, key };
      });
    }
  } catch (error) {
    snackbar.show('Settings жүктеу мүмкін болмады', 'error');
  } finally {
    loading.value = false;
  }
};

// Save all settings
const saveAllSettings = async () => {
  loading.value = true;
  try {
    let successCount = 0;
    
    // Save each setting with all language versions
    for (const key in settings.value) {
      const value = settings.value[key];
      if (!value) continue;

      const data = {
        valueKz: value.kz || '',
        valueRu: value.ru || '',
        valueEn: value.en || '',
        dataType: 'text'
      };

      try {
        await api.put(`/admin/settings/${key}`, data);
        successCount++;
      } catch (error) {
        // Continue with other settings
      }
    }
    
    if (successCount > 0) {
      snackbar.show(`${successCount} баптау сәтті жаңартылды`, 'success');
      // Reload to get updated data
      await loadSettings();
    }
  } catch (error) {
    snackbar.show('Баптауларды жаңарту мүмкін болмады', 'error');
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  loadSettings();
});
</script>

<style scoped>
.h-100 {
  height: 100%;
}

.v-card-title {
  font-weight: 600;
}

.text-caption {
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
}
</style>
